import React, { createContext, useContext } from 'react';

import { UserOrganization } from '../../common/constants/userOrganization';
import { FeatureFlagsContext } from '../../common/featureFlagsWrapper';
import { AuthContext } from '../login/AuthWrapper';
import { useReferralActionRequiredCount } from './useReferralActionRequiredCount';

interface ReferralCountContextValue {
  count: number;
  refetch: () => Promise<void>;
}

export const ReferralCountContext = createContext<ReferralCountContextValue>({
  count: 0,
  refetch: () => Promise.resolve(),
});

export const ReferralCountProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const auth = useContext(AuthContext);
  const { flags } = useContext(FeatureFlagsContext);
  const isReferralEnabled =
    flags.isCaseReferralEnabled &&
    auth.userOrganization === UserOrganization.ETHOS;

  // Fetched globally so the sidebar and header badges stay accurate on every
  // page. The throttling is avoided by react-query (shared query key + staleTime
  // + a fixed background poll), so navigation never triggers extra requests.
  const { count, refetch } = useReferralActionRequiredCount(isReferralEnabled);

  return (
    <ReferralCountContext.Provider value={{ count, refetch }}>
      {children}
    </ReferralCountContext.Provider>
  );
};
